// extracted by mini-css-extract-plugin
export default {"actionButton":"MBRUploadModal__actionButton___wraJw","detailItem":"MBRUploadModal__detailItem___u0vE5"};